// extracted by mini-css-extract-plugin
export var button = "_de-7";
export var buttonRow = "_de-6";
export var fadeIn = "_de-1";
export var gradient = "_de-0";
export var panel = "_de-2";
export var panelIn = "_de-3";
export var subtitle = "_de-5";
export var title = "_de-4";